import { render, staticRenderFns } from "./frontChild.vue?vue&type=template&id=5dfc704c&scoped=true&"
import script from "./frontChild.vue?vue&type=script&lang=js&"
export * from "./frontChild.vue?vue&type=script&lang=js&"
import style0 from "./frontChild.vue?vue&type=style&index=0&id=5dfc704c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfc704c",
  null
  
)

export default component.exports